import { useMemo } from "react";

import { HotelClinicArrivalCommonProps } from "@/constants/hotelClinicArrivalSections";
import { useClinicUnassignedCancelledFilter } from "@/stores/use-clinic-arrival-unassigned-passengers-table";

import UnAssignedPassengersTable from "../components/unAssignedPassengersTable";
import { HotelClinicListItem } from "../types";

export function ClinicArrivalUnassignedSection({ data, loading = false, ...section }: HotelClinicArrivalCommonProps) {
    const cancelledPassengersFilterActive = useClinicUnassignedCancelledFilter();
    const allRows = useMemo((): HotelClinicListItem[] => data.unassignedPassengers, [data]);

    const rows = useMemo(() => {
        if (!cancelledPassengersFilterActive) return allRows;
        return allRows.filter((p) => !p.cancelled);
    }, [cancelledPassengersFilterActive, allRows]);

    return <UnAssignedPassengersTable rows={rows} allRows={allRows} loading={loading} {...section} />;
}
